import React from 'react';
import {SHARED_FORM_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {SHARED_INPUT_WRAPPER_CONSTRAINTS_DESCENDANTS} from '@packages/shared/constants/inputWrapperConstraints';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceCheckoutAdditionalCheckboxWrapper = Atom.createRender(
  ({attributes, classes, context, data, generateAttributes, renderChild}) => {
    const isIncluded = context.get('includeCheckbox', true);

    return isIncluded ? (
      // TODO: fix jsx-a11y lint error
      // eslint-disable-next-line jsx-a11y/label-has-for
      <label {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </label>
    ) : null;
  }
);

const config = createIntegratedAtom({
  displayName: 'Checkbox Field',
  showEmpty: true,
  constraints: {
    ancestors: [
      {is: 'CommerceCheckoutAdditionalInputsContainer', rule: 'ExactlyOne'},
    ],
    descendants: [
      ...SHARED_FORM_CONSTRAINTS_DESCENDANTS,
      ...SHARED_INPUT_WRAPPER_CONSTRAINTS_DESCENDANTS,
      {is: 'CommerceCheckoutAdditionalCheckbox', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        },
      },
    },
  },
  render: CommerceCheckoutAdditionalCheckboxWrapper,
  fields: {children: TListOfElement},
});

export default config;
